import React, { useMemo, useState } from "react"

import { A } from "../../utils/router"
import FooterMenuStyles from "./footer-v2.module.css"
import classNames from "classnames"
import { findTranslation } from "../../utils/find-translation"
import { menu } from "../../config/footer-menu-v2"
import { useLocalesState } from "../../context/locales"

const FooterMenu = () => {
    const { language, region } = useLocalesState()

    const filteredMenu = useMemo(
        () =>
            menu.filter(
                m =>
                    findTranslation(m, language)?.title && !findTranslation(m, language)?.hiddenRegion?.includes(region)
            ),
        [language, region]
    )

    const [open, setOpen] = useState(filteredMenu.map(() => false))

    if (filteredMenu.length === 0) return null

    return filteredMenu.map((m, i) => (
        <div className={FooterMenuStyles.menu} key={m.id}>
            <button
                className={classNames(FooterMenuStyles.button, { [FooterMenuStyles.buttonActive]: open[i] })}
                onClick={() => {
                    setOpen(open => {
                        const newOpen = [...open]
                        newOpen[i] = !newOpen[i]
                        return newOpen
                    })
                }}
            >
                <span>{findTranslation(m, language)?.title}</span>
                <i className={classNames("lavita-icon", FooterMenuStyles.buttonIcon)}></i>
            </button>
            <div className={FooterMenuStyles.listWrapper}>
                <ul className={FooterMenuStyles.list}>
                    {m.options?.map(o => {
                        if (
                            !findTranslation(o, language)?.title ||
                            findTranslation(o, language)?.hiddenRegion?.includes(region)
                        )
                            return null
                        return (
                            <li key={o.id}>
                                <A href={findTranslation(o, language).url} className={FooterMenuStyles.item}>
                                    {findTranslation(o, language).title}
                                </A>
                            </li>
                        )
                    })}
                </ul>
            </div>
        </div>
    ))
}

export default React.memo(FooterMenu)
